module.exports = __webpack_public_path__ + "static/media/right-svgrepo-com.beb0dab2.svg";